import React from 'react';
import BaseInput from '../Base/BaseInput';
import { ShiftGroup } from '../../models/ShiftGroupModel';
import {
  finalizeFormTextField,
  sanitizeFormTextField,
} from '../../utils/textInputSanitize';

type Props = {
  value: ShiftGroup;
  onChange: (v: ShiftGroup) => void;
  error?: string | null;
  fieldErrors?: Record<string, string>;
};

const ShiftGroupForm: React.FC<Props> = ({ value, onChange, fieldErrors = {} }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: sanitizeFormTextField(name, v) });
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    const next = finalizeFormTextField(name, v);
    if (next !== (value as any)[name]) {
      onChange({ ...value, [name]: next });
    }
  };

  return (
    <div className="shift-group-form">
      <BaseInput
        label="Nombre del grupo"
        name="name"
        value={value.name ?? ''}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        autoFocus
        maxLength={120}
        error={fieldErrors.name}
      />
    </div>
  );
};

export default ShiftGroupForm;
